const sculptureList = [
    {
        id: 0,
        title: "Forest of Symbols, 2017",
        image: require("./assets/sculpture-1.webp"),
        measurement: '100cm x 30cm approx',
        description: 'white clay, clear glaze'

    },
    {
        id: 1,
        title: "Crouching Venus",
        image: require("./assets/sculpture-2.webp"),
        measurement: '45cm x 35cm',
        description: 'copper oxide, clear glaze, glass shards, cement'

    },
    {
        id: 2,
        title: "Rocks",
        image: require("./assets/sculpture-3.webp"),
        measurement: '18cm x 15cm & 33cm x 26cm',
        description: 'white clay, copper oxide, lead glaze & terracotta, opaque glaze, epoxy putty'

    },
    {
        id: 3,
        title: "Acanthus Fire",
        image: require("./assets/sculpture-6.webp"),
        measurement: ' 68cm x 75cm',
        description: 'white clay, iron oxide, copper oxide, partly glazed with clear glaze'

    },
   
 
     

]

export default sculptureList;